export const TopProductsGridAreaName = 'topProducts';
